<template>
  <a-spin :spinning="confirmLoading">
    <div class="driver-form-box" :class="disabled?'disabled-form':'no-disabled-form'" :style="{height:(height-subHeight)+'px'}">
      <div class="driver-form-box-left">
      <j-form-container>
        <a-form :form="form" slot="detail">
          <div class="driver-new-box" :style="{height:(height-subHeight)+'px'}">
            <div ref="scrollDiv" class="driver-new-box-left" :style="{height:(height-subHeight-24)+'px'}">
              <div>
                <div style="margin-bottom: 10px" class="font-16">行驶证正本</div>
                <a-col :span="24" @mouseover="hoverSpace(0)">
                  <a-form-item  >
                    <j-image-upload-new :number="3" :width="180"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('drivingLicenseMaster')"
                                        :height="108"  @change="checkChange('drivingLicenseMaster')"
                                        :disabled="disabled" bizPath="drivingLicenseMaster"
                                        :scan="disabled?'':'vehicleLicense'"  @getImgState="getImgState"   @scanOk="getOcrInfo"   v-decorator="['drivingLicenseMaster', validatorRules.drivingLicenseMaster]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>
              </div>
              <div>
                <div style="margin-bottom: 12px" class="font-16">行驶证附页</div>
                <a-col  :span="24"  @mouseover="hoverSpace(0)">
                  <a-form-item  >
                    <j-image-upload-new :number="3" :width="180" :height="108"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('drivingLicenseSlave')"
                                        @change="checkChange('drivingLicenseSlave')" :disabled="disabled"
                                        bizPath="drivingLicenseSlave"   @getImgState="getImgState"
                                        v-decorator="['drivingLicenseSlave', validatorRules.drivingLicenseSlave]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>
              </div>

              <div >
                <div style="margin-bottom: 12px" class="font-16">车头照片</div>
                <a-col :span="24"  @mouseover="hoverSpace(1032)">
                  <a-form-item  >
                    <j-image-upload-new :number="3" :width="180" :height="108"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('carHeadImg')"
                                        bizPath="carHeadImg" @change="checkChange('carHeadImg')" :disabled="disabled"    @getImgState="getImgState"   v-decorator="['carHeadImg', validatorRules.carHeadImg]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>
              </div>
              <div>
                <div style="margin-bottom: 12px" class="font-16">车尾照片</div>
                <a-col  :span="24"  @mouseover="hoverSpace(1032)">
                  <a-form-item  >
                    <j-image-upload-new :number="3" :width="180" :height="108"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('carFooterImg')"
                                        bizPath="carFooterImg" @change="checkChange('carFooterImg')"  :disabled="disabled"   @getImgState="getImgState"    v-decorator="['carFooterImg', validatorRules.carFooterImg]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>
              </div>

              <div>
                <div style="margin-bottom: 12px" class="font-16">车架号</div>
                <a-col  :span="24"  @mouseover="hoverSpace(1152)">
                  <a-form-item  >
                    <j-image-upload-new :number="3" :width="180" :height="108"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('carFrameNoImg')"
                                        @change="checkChange('carFrameNoImg')" :disabled="disabled" bizPath="carFrameNoImg"   @getImgState="getImgState"    v-decorator="['carFrameNoImg', validatorRules.carFrameNoImg]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>
              </div>

              <div>
                <div style="margin-bottom: 12px" class="font-16">车证照片</div>
                <a-col :span="24"  @mouseover="hoverSpace(1248)">

                  <a-form-item >
                    <j-image-upload-new :number="3" :width="180" :height="108"
                                        @setValue="setValue"
                                        @tranferToRight="tranferToRight('carLicenseImg')"
                                        @change="checkChange('carLicenseImg')"  :disabled="disabled" bizPath="carLicenseImg"   @getImgState="getImgState"    v-decorator="['carLicenseImg', validatorRules.carLicenseImg]" ></j-image-upload-new>
                  </a-form-item>
                </a-col>

              </div>
            </div>
            <div class="driver-new-box-right" ref="scrollRight"  :style="{height:(height-subHeight-24)+'px'}">
              <div class="driver-new-box-item">
                  <div class="driver-label-title font-16">车牌号</div>
                <div class="driver-value-ipt">
                  <a-form-item label="" :labelCol="labelCol"  :wrapperCol="wrapperCol" >
                    <a-input @change="checkChange('licensePlateNumber')"  :disabled="disabled"
                              :trigger-change="true"
                             style="width: 100%"
                             v-decorator="['licensePlateNumber', validatorRules.licensePlateNumber]"
                             :placeholder="disabled?'':'请输入车牌号'" ></a-input>
                  </a-form-item>
                </div>
              </div>
              <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">车辆品牌</div>
                <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-search-select-tag
                      :disabled="disabled"
                      :placeholder="disabled?'':'请选择车辆品牌'"
                      @change="checkBrand"
                      v-decorator="['brandId', validatorRules.brandId]"
                      @mouseover="hoverA('brandId',model.id)"
                      style="width: 100%"
                      @mouseleave="unHoverA('fbrandId')"
                      :trigger-change="true"
                      :dictOptions="brandList">
                    </j-search-select-tag>
                  </a-form-item>
                </div>
              </div>

              <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">车系</div>
                <div class="driver-value-ipt">
                <a-form-item label="" >
                    <j-search-select-tag
                      :disabled="disabled"
                      :placeholder="disabled?'':'请选择车系'"
                      @change="checkChange('modelId')"
                      ref="modelSelect"
                      style="width: 100%"
                      v-decorator="['modelId', validatorRules.modelId]"
                      @mouseover="hoverA('modelId',model.id)"
                      @mouseleave="unHoverA('fmodelId')"
                      :trigger-change="true"
                      :dictOptions="modelList">
                    </j-search-select-tag>
                  </a-form-item>
                </div>
              </div>
              <div class="driver-new-box-item">
                <div class="driver-label-title font-16 margin-top-2">使用性质</div>
                <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-dict-select-tag   @change="checkChange('useNature')"
                                         @mouseover="hoverA('useNature',model.id)"
                                         @mouseleave="unHoverA('fuseNature')"
                                         :trigger-change="true"
                                         style="width: 100%"
                                         :style="{position: 'relative'}"
                                         :disabled="disabled" type="list" v-decorator="['useNature', validatorRules.useNature]"
                                         dictCode="use_nature"
                                         :placeholder="disabled?'':'请选择使用性质'"/>
                  </a-form-item>
                </div>
              </div>
              <div class="driver-new-box-item">
                <div class="driver-label-title font-16">车辆颜色</div>
                <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-search-select-tag @change="checkChange('carColor')"
                                       @mouseover="hoverA('carColor',model.id)"
                                       @mouseleave="unHoverA('fcarColor')"
                                       :trigger-change="true"
                                       style="width: 100%"
                                       :style="{position: 'relative'}"
                                       :disabled="disabled" type="list" v-decorator="['carColor', validatorRules.carColor]"
                                         dict="car_color"
                                       :placeholder="disabled?'':'请选择车辆颜色'" />
                  </a-form-item>
                </div>
              </div>

              <div class="driver-new-box-item">
                <div class="driver-label-title font-16">VIN码</div>
                <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <a-input @change="checkChange('vin')" :disabled="disabled"
                             @mouseover="hoverA('vin',model.id)" @mouseleave="unHoverA('fvin')"
                             :trigger-change="true"
                             style="width: 100%"
                             :placeholder="disabled?'':'请输入VIN码'"
                             v-decorator="['vin', validatorRules.vin]"  ></a-input>
                  </a-form-item>
                </div>
              </div>

              <div class="driver-new-box-item" style="margin-top: 30px">
                  <div class="driver-label-title font-16 margin-top-2">车辆所有人</div>
                  <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <a-input @change="checkChange('owner')"
                             @mouseover="hoverA('owner',model.id)" @mouseleave="unHoverA('fowner')"
                             :trigger-change="true"
                             style="width: 100%"
                             :disabled="disabled" v-decorator="['owner', validatorRules.owner]" :placeholder="disabled?'':'请输入车辆所有人'"  ></a-input>
                  </a-form-item>
                  </div>
                </div>
                  <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">所有人地址</div>
                    <div class="driver-value-ipt">
                    <a-form-item label="" >
                    <a-input  @change="checkChange('address')" :disabled="disabled"
                              @mouseover="hoverA('address',model.id)" @mouseleave="unHoverA('faddress')"
                              :trigger-change="true"
                              style="width: 100%"
                              v-decorator="['address', validatorRules.address]" :placeholder="disabled?'':'请输入所有人地址'"  ></a-input>
                  </a-form-item>
                    </div>
                  </div>

                      <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">注册日期</div>
                        <div class="driver-value-ipt">
                        <a-form-item label="" >
                    <j-date  @change="checkChange('registrationTime')" :disabled="disabled" v-decorator="['registrationTime', validatorRules.registrationTime]" :trigger-change="true"
                             @mouseover="hoverA('registrationTime',model.id)" @mouseleave="unHoverA('fregistrationTime')" :placeholder="disabled?'':'请选择注册日期'"
                             style="width: 100%" />
                  </a-form-item>
                        </div>
                      </div>

                        <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">发证日期</div>
                          <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-date  @change="checkChange('fzTime')" :disabled="disabled"
                             @mouseover="hoverA('fzTime',model.id)" @mouseleave="unHoverA('ffzTime')" :placeholder="disabled?'':'请选择发证日期'"
                             v-decorator="['fzTime', validatorRules.fzTime]" :trigger-change="true" style="width: 100%" />
                  </a-form-item>
                          </div>
                        </div>

                          <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">发动机号</div>
                            <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <a-input  @change="checkChange('engineNumber')" :disabled="disabled"
                              @mouseover="hoverA('engineNumber',model.id)" @mouseleave="unHoverA('fengineNumber')"
                              :trigger-change="true"
                              style="width: 100%"
                              v-decorator="['engineNumber', validatorRules.engineNumber]"
                              :placeholder="disabled?'':'请输入发动机号'"></a-input>
                  </a-form-item>
                            </div>
                          </div>
                            <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">厂家品牌型号</div>
                              <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <a-input  @change="checkChange('modelNo')"
                              @mouseover="hoverA('modelNo',model.id)" @mouseleave="unHoverA('fmodelNo')"
                              :trigger-change="true"
                              style="width: 100%"
                              :disabled="disabled" v-decorator="['modelNo', validatorRules.modelNo]"
                              :placeholder="disabled?'':'请输入厂家品牌型号'"  ></a-input>
                  </a-form-item>
                              </div>
                            </div>

                                <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">车牌颜色</div>
                                  <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-dict-select-tag @change="checkChange('plateColor')"
                                       @mouseover="hoverA('plateColor',model.id)"
                                       @mouseleave="unHoverA('fplateColor')"
                                       :style="{position: 'relative'}"
                                       style="width: 100%"
                                       :disabled="disabled" type="list" v-decorator="['plateColor', validatorRules.plateColor]"
                                       :trigger-change="true" dictCode="plate_color"  :placeholder="disabled?'':'请选择车牌颜色'" />
                  </a-form-item>
                                  </div>
                                </div>

                                    <div class="driver-new-box-item" style="margin-top: 30px">
                  <div class="driver-label-title font-16 ">车证核验</div>
                                      <div class="driver-value-ipt">
                  <a-form-item label="" >
                    <j-dict-select-tag style="width: 100%"  :disabled="disabled" @change="checkChange('licenseFlag')"  @mouseover="hoverA('licenseFlag',model.id)" @mouseleave="unHoverA('flicenseFlag')" type="list"  v-decorator="['licenseFlag', validatorRules.licenseFlag]" :trigger-change="true" dictCode="car_license_flag" :placeholder="disabled?'':'请选择车证核验'" />
                  </a-form-item>
                                      </div>
                                    </div>
                                      <div class="driver-new-box-item">
                  <div class="driver-label-title font-16">运输证字号</div>
                                        <div class="driver-value-ipt">
                                        <a-form-item label="" >
                    <a-input @change="checkChange('transportLicenseNo')"
                             @mouseover="hoverA('transportLicenseNo',model.id)" @mouseleave="unHoverA('ftransportLicenseNo')"
                             :trigger-change="true"
                             style="width: 100%"
                             :disabled="disabled" v-decorator="['transportLicenseNo', validatorRules.transportLicenseNo]"
                             :placeholder="disabled?'':'请输入运输证字号'"></a-input>
                  </a-form-item>
                                        </div>
                                      </div>
                                        <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">生效日期</div>
                                          <div class="driver-value-ipt">
                                          <a-form-item label="" >
                    <j-date @change="checkChange('effectTime')" :disabled="disabled"
                            @mouseover="hoverA('effectTime',model.id)" @mouseleave="unHoverA('feffectTime')"
                            :placeholder="disabled?'':'请选择生效日期'"
                            v-decorator="['effectTime', validatorRules.effectTime]"
                            :trigger-change="true" style="width: 100%" />
                  </a-form-item>
                                          </div>
                                        </div>
                                          <div class="driver-new-box-item">
                  <div class="driver-label-title font-16 margin-top-2">失效日期</div>
                                            <div class="driver-value-ipt">
                                            <a-form-item label="" >
                    <j-date @change="checkChange('invalidTime')"  :disabled="disabled"

                            @mouseover="hoverA('invalidTime',model.id)" @mouseleave="unHoverA('finvalidTime')" :placeholder="disabled?'':'请选择失效日期'"
                            v-decorator="['invalidTime', validatorRules.invalidTime]" :trigger-change="true" style="width: 100%" />
                  </a-form-item>
                            </div>
                          </div>
              </div>
          </div>
        </a-form>
      </j-form-container>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel()">
        <img alt="example" style="width: 100%" :src="previewImage"/>
      </a-modal>
    </div>
    <div class="driver-form-box-right">
      <div class="other-image">其他照片</div>
      <div class="other-image-list">
        <div  v-for="(item,idx) in otherImg">
          <j-image-upload-new  :number="1"
                               bizPath="otherImg"
                               v-if="!disabled && !item.fileUrl"
                               :disabled="disabled"
                               v-model="fileUrl"
                               :tzType="2"
                               @change="changeOtherImg(idx)"
                               :width="164" :height="108"
                               url="https://www.surely.cool/surely-vue-logo.png">
          </j-image-upload-new>
          <div style="position: relative;" v-if="item.fileUrl">
            <div class="delete-img"  @click.stop="deleteImg(idx)" v-if="!disabled">
              <img   src="@/assets/driver/delete.png"/>
            </div>
          <img :src="getFileAccessHttpUrl(item.fileUrl)"
               :alt="item.fileUrl"
               @click="viewOtherImage(item.fileUrl)"
               @dragstart="handleDragStart($event, item.fileUrl)"
               draggable="true"/>
          </div>
        </div>
      </div>
      <div ref="viewer" class="images" v-viewer="viewerOptions" style="display: none;">
        <img :src="previewImage" :key="previewImage">
      </div>
    </div>
    </div>
<repeat-car-list ref="repeat" @ok="getInfo" @close="closeTab"></repeat-car-list>
  </a-spin>
</template>

<script>
import { CarFormMixins } from '@/mixins/dm5/car/CarFormMixins'
  import RepeatCarList from "@views/dm3/car/modal/RepeatCarList";
import {getFileAccessHttpUrl} from "@api/manage";
  export default {
    name: 'DmCarForm',
    methods: {getFileAccessHttpUrl},
    inject:["closeCurrent"],
    mixins: [CarFormMixins],
    components: {
      RepeatCarList
    },

  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/form.less';
@import '~@assets/less/dm5/driver/driverForm.less';

</style>